import type { SelectorCreator, Slicer } from '@swf/core/store';

import type { SportsSeoState } from './types';

export const selectors = (slice: Slicer<SportsSeoState>, createSelector: SelectorCreator) => ({
  tokens: () => slice((state) => state.tokens),
  redirect: () => slice((state) => state.redirect),
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  alternates: () => slice((state) => state.alternates ?? [])
});
